import { get } from "../../../Services/http";
import { catchError } from "../../../Actions/Error.action";

export const FMG_FORM_BLOCK_RECEIVE = 'FMG_FORM_BLOCK_RECEIVE';
export const FMG_FORM_BLOCK_ERROR = 'FMG_FORM_BLOCK_ERROR';

export const fetchFMGFormModel = (id) => (dispatch) => {
    return get('/api/fmgFormBlock/' + id)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const receive = result => ({
    type: FMG_FORM_BLOCK_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: FMG_FORM_BLOCK_ERROR,
    payload: {
        error,
    },
})